// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vectorFileTitle img {
    margin-right: 6px;
    vertical-align: text-top;
}
.centerflex
{
    display: grid;
    justify-content: center;
    align-items: center;
}
.centerflex div{
    text-align: center;
}

.show-data-table{
    position: relative;
}

.next-btn{
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1000;
}
.mat-stepperdiv {
    height: calc(100vh - 50px);
    overflow: auto;
  }
  .mt-15{
    margin-top: 15px;
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
   ::-webkit-scrollbar-thumb {
    background: #003561;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  mat-icon{
    cursor: pointer;
  }
  .note{
    background-color: pink;
  }
  .activemode
  {
    background-color: #fff;
  }
  .save-publish-btn{
    height: 35px;
    width: max-content;
  }

  .active-module-btn{
    color: whitesmoke;
    background-color: rebeccapurple;
  }
  
  .module-btn{
      margin: 5px;
      border-radius: 33px;
      border: 1px solid gray;
  }

  .width-100 {
    width: 100%;
}

.addmat {
  position: relative;
  top: -1px;
  left: -5px;
}

.ml-3{
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/assign-user/assign-user-tool/assign-user-tool.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;AACjB;AACA;IACI,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,WAAW;EACb;GACC;IACC,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;MACI,WAAW;MACX,mBAAmB;MACnB,sBAAsB;EAC1B;;EAEA;IACE,WAAW;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".vectorFileTitle img {\n    margin-right: 6px;\n    vertical-align: text-top;\n}\n.centerflex\n{\n    display: grid;\n    justify-content: center;\n    align-items: center;\n}\n.centerflex div{\n    text-align: center;\n}\n\n.show-data-table{\n    position: relative;\n}\n\n.next-btn{\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    z-index: 1000;\n}\n.mat-stepperdiv {\n    height: calc(100vh - 50px);\n    overflow: auto;\n  }\n  .mt-15{\n    margin-top: 15px;\n  }\n  ::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n   ::-webkit-scrollbar-thumb {\n    background: #003561;\n    border-radius: 10px;\n  }\n  ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  mat-icon{\n    cursor: pointer;\n  }\n  .note{\n    background-color: pink;\n  }\n  .activemode\n  {\n    background-color: #fff;\n  }\n  .save-publish-btn{\n    height: 35px;\n    width: max-content;\n  }\n\n  .active-module-btn{\n    color: whitesmoke;\n    background-color: rebeccapurple;\n  }\n  \n  .module-btn{\n      margin: 5px;\n      border-radius: 33px;\n      border: 1px solid gray;\n  }\n\n  .width-100 {\n    width: 100%;\n}\n\n.addmat {\n  position: relative;\n  top: -1px;\n  left: -5px;\n}\n\n.ml-3{\n  margin-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
